import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { GetUserBrandingResponse } from "@shared/apis/sidekick/generated";
import {
  ApiError,
  apiResponseErrorHandler,
} from "@shared/apis/sidekick/api-error-handler";

export const GET_USER_BRANDING_QUERY_KEY = "user-branding";

type Props = {
  onSuccess?: (data: GetUserBrandingResponse) => void;
  onError?: (error: ApiError) => void;
  onSettled?: () => void;
  enabled?: boolean;
};

const CACHE_TIME_IN_MS = 1000 * 60 * 1; // 1 hour

export const useGetUserBranding = (props?: Props) => {
  const { enabled = false, onSuccess, onError, onSettled } = props || {};
  const api = getUsersApiClient();
  const query = useQuery({
    queryKey: [GET_USER_BRANDING_QUERY_KEY],
    queryFn: async () => {
      try {
        const data = await api.userControllerGetBranding();
        onSuccess?.(data);
        return data;
      } catch (error) {
        console.error("Failed to get user branding.", error);
        const apiError = await apiResponseErrorHandler(error);
        onError?.(apiError);
        throw error;
      } finally {
        onSettled?.();
      }
    },
    enabled,
    retry: false,
    gcTime: CACHE_TIME_IN_MS,
    staleTime: CACHE_TIME_IN_MS,
  });

  return extractQueryState(query);
};
